import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dotProp from 'dot-prop-immutable';
import { findIndex, keys, propEq } from 'ramda';
import * as actions from '@/redux/actions/training/course-tag';
import * as actionsTrainingFavorites from '@/redux/actions/training/favorites';
export var initialState = {
  objects: {}
};
export var reducerTrainingTags = function reducerTrainingTags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions.COURSES_FETCH_WITH_TAG_ERROR:
    case actions.COURSES_FETCH_WITH_TAG_START:
      return _objectSpread({}, state);

    case actions.COURSES_FETCH_WITH_TAG_SUCCESS:
      return dotProp.set(state, "objects.".concat(action.payload.tag.id), action.payload.tag);

    case actionsTrainingFavorites.COURSE_FAVOURITE_UPDATE_START:
    case actionsTrainingFavorites.COURSE_FAVOURITE_UPDATE_SUCCESS:
    case actionsTrainingFavorites.COURSE_FAVOURITE_UPDATE_ERROR:
      return dotProp.set(state, 'objects', function (objects) {
        return keys(objects).reduce(function (accumulator, currentValue) {
          var courses = accumulator[currentValue].courses;
          var courseIndex = findIndex(propEq('slug', action.payload.slug))(courses);

          if (courseIndex === -1) {
            return accumulator;
          }

          return dotProp.set(accumulator, "".concat(String(currentValue), ".courses.").concat(courseIndex, ".favorite"), action.payload.favorite);
        }, objects);
      });

    default:
      return state;
  }
};
export default reducerTrainingTags;